export default { required: true, message: 'Please specify' }
